// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"StickyHeader_stickyHeader__cg5C6"};